import { render, staticRenderFns } from "./ProductVariantTable.vue?vue&type=template&id=9d003e7a&scoped=true"
import script from "./ProductVariantTable.vue?vue&type=script&lang=ts"
export * from "./ProductVariantTable.vue?vue&type=script&lang=ts"
import style0 from "./ProductVariantTable.vue?vue&type=style&index=0&id=9d003e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d003e7a",
  null
  
)

export default component.exports